import axios from 'axios'
import { ElMessage } from 'element-plus'
import router from '@/router'

// 创建 axios 实例
const service = axios.create({
  baseURL: '/api', // 生产环境走 nginx 代理，开发环境走 vue devServer 代理
  timeout: 15000
})

// 获取 Token
const getToken = () => {
  return localStorage.getItem('token')
}

// 请求拦截器
service.interceptors.request.use(
  config => {
    const token = getToken()
    if (token) {
      config.headers['Authorization'] = 'Bearer ' + token
    }
    return config
  },
  error => {
    console.error('请求错误:', error)
    return Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    const res = response.data

    // 如果是文件流，直接返回
    if (response.config.responseType === 'blob') {
      return res
    }

    // 状态码判断 (根据后端 ResponseBean 定义: 200 为成功)
    if (res.code == 200) {
      return res
    } else {
      ElMessage.error(res.msg || '请求失败')
      return Promise.reject(new Error(res.msg || '请求失败'))
    }
  },
  error => {
    if (error.response) {
      const status = error.response.status

      if (status === 403) {
        ElMessage.error('您没有权限执行此操作')
        // 返回一个带标记的 Error，在 main.js 中被全局拦截
        const error = new Error('PermissionDenied')
        error.isPermissionError = true
        return Promise.reject(error)
      }

      console.error('响应错误:', error)

      if (status === 401) {
        // Token 失效，清除本地登录状态
        localStorage.removeItem('token')
        localStorage.removeItem('username')
        ElMessage.error('登录已过期，请重新登录')
        router.push({ name: 'Login' })
      } else if (status === 404) {
        ElMessage.error('请求的资源不存在')
      } else if (status === 500) {
        ElMessage.error('服务器错误')
      } else {
        ElMessage.error(error.response.data?.msg || '请求失败')
      }
    } else {
      console.error('响应错误:', error)
      ElMessage.error('网络连接失败')
    }

    return Promise.reject(error)
  }
)

export default service
